import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const ConsultancyNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isLoggedIn = Boolean(localStorage.getItem("token") || localStorage.getItem("id"));
  const role = localStorage.getItem("role") || localStorage.getItem("userRole") || "";
  const dashboardPath = role.includes("SUPER_ADMIN") || role.includes("super-admin")
    ? "/superadmin"
    : role.includes("ADMIN") || role.includes("admin")
    ? "/admindashboard"
    : "/dashboard";

  const navItems = [
    { name: "Product", path: "/" },
    { name: "Solutions", path: "/consultancy/services" },
    { name: "Features", path: "/consultancy/courses" },
    { name: "Integrations", path: "/consultancy/universities" },
    { name: "Pricing", path: "/#pricing" },
    { name: "Resources", path: "/consultancy/blog" },
    { name: "About Us", path: "/consultancy/about" },
    { name: "Contact", path: "/consultancy/contact" },
  ];

  const handleNavClick = (e, item) => {
    if (item.path.includes("pricing")) {
      e.preventDefault();
      const pricingEl = document.getElementById("pricing");
      if (pricingEl) {
        const yOffset = -90;
        const y = pricingEl.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        window.location.href = "/#pricing";
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`consultancy-navbar py-3 ${scrolled ? "scrolled" : ""}`}>
        <div className="consultancy-navbar-container container-fluid px-3 px-md-4 px-lg-5 d-flex align-items-center justify-content-between">
          {/* Brand Logo */}
          <Link to="/" className="d-flex align-items-center text-decoration-none">
            <span className="font-weight-bold text-white fs-5 ml-2">EDOPS OS</span>
          </Link>

          {/* Desktop Navigation Links */}
          <div className="d-none d-xl-flex align-items-center gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path || (item.path.includes("#pricing") && location.hash === "#pricing");
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`consultancy-nav-link ${isActive ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, item)}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>

          {/* Desktop Right CTA */}
          <div className="d-none d-xl-flex align-items-center gap-2">
            {isLoggedIn ? (
              <Link to={dashboardPath} className="consultancy-btn-gold py-2 px-4">
                <i className="fas fa-th-large mr-1"></i> Dashboard
              </Link>
            ) : (
              <Link to="/login" className="consultancy-btn-gold py-2 px-4">
                <i className="fas fa-sign-in-alt mr-1"></i> Login
              </Link>
            )}
          </div>

          {/* Mobile Hamburger Toggle */}
          <button
            className="btn d-xl-none text-warning border-0 p-2"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`fas ${mobileMenuOpen ? "fa-times" : "fa-bars"} fa-lg`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Drawer Navigation */}
      {mobileMenuOpen && (
        <div
          className="position-fixed w-100 h-100 top-0 start-0"
          style={{ backgroundColor: "rgba(0,0,0,0.75)", zIndex: 1090 }}
          onClick={() => setMobileMenuOpen(false)}
        >
          <div
            className="consultancy-mobile-drawer"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-between align-items-center mb-4 pb-3" style={{ borderBottom: "1px solid rgba(212, 175, 55, 0.15)" }}>
              <span className="consultancy-gold-title font-weight-bold">Platform Menu</span>
              <button className="btn text-white p-0" onClick={() => setMobileMenuOpen(false)}>
                <i className="fas fa-times fa-lg"></i>
              </button>
            </div>

            <div className="d-flex flex-column gap-2 mb-4">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="consultancy-nav-link py-2.5 px-3 rounded"
                  onClick={(e) => handleNavClick(e, item)}
                >
                  {item.name}
                </Link>
              ))}
            </div>

            <div className="mt-auto pt-3 d-flex flex-column gap-2" style={{ borderTop: "1px solid rgba(212, 175, 55, 0.15)" }}>
              {isLoggedIn ? (
                <Link
                  to={dashboardPath}
                  className="consultancy-btn-gold w-100 text-center py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="fas fa-th-large mr-1"></i> Dashboard
                </Link>
              ) : (
                <Link
                  to="/login"
                  className="consultancy-btn-gold w-100 text-center py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="fas fa-sign-in-alt mr-1"></i> Login
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultancyNavbar;
